import React from "react";
import {Button,Col,Container,Form, InputGroup, Row } from "react-bootstrap";
import logo from "../../../assets/images/logo.png";
import google from "../../../assets/images/icons/google.svg";
import fb_icon from "../../../assets/images/icons/fb_icon.svg";
import { NavLink } from "react-router-dom";

function VerificationCodeComponent(){
    return(
        <>
            
            <div className="text-center">
                <NavLink to="/" className="navbar-brand">
                    <img loading="lazy"  src={logo} />
                </NavLink>
            </div>
            <div className="d-flex align-items-center justify-content-center my-4">
                <h1 className="fs-36 fw-400 m-0">Enter your Verification code</h1> 
            </div>
            <p className="text-center fs-16 fw-400">We Have sent the code verification to your Email</p>
            <Form>
                <InputGroup className="mb-4" controlId="formBasicEmail">
                    <Form.Control className="fs-16 fw-400" type="email" placeholder="" />
                    <Form.Control className="fs-16 fw-400" type="email" placeholder="" />
                    <Form.Control className="fs-16 fw-400" type="email" placeholder="" />
                    <Form.Control className="fs-16 fw-400" type="email" placeholder="" />
                </InputGroup>

                <div className="d-grid mb-4">
                    <Button variant="warning" type="submit">Submit</Button>
                </div>

                <div className="text-center mt-4">
                    <p className="fs-16 fw-400">don't receive OTP?  <NavLink className="text-light-yellow" to="/resend">Resend</NavLink></p>
                </div>
            </Form>  
  
        </>
    )
}

export default VerificationCodeComponent;